@use '../../styling/colors.scss' as *;

.SortButton {
  border: 0;
  padding: 0;
  background: none;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  text-align: left;
  font-family: inherit;
  font-weight: inherit;
  position: relative;
  padding-right: 1.75em;
  display: inline-flex;

  [class^='SortIndicator'] {
    position: absolute;
    right: 0;
    top: 4px;
  }
}
